import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  IconButton,
  Divider,
} from "@mui/material";
import { Close as CloseIcon, StickyNote2 as NoteIcon } from "@mui/icons-material";

const NotesModal = ({ open, onClose, notes = [] }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          maxHeight: "80vh",
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: "#9D2235",
          color: "white",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <NoteIcon />
          <Typography variant="h6">My Notes</Typography>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{
            color: "white",
            "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        {notes.length === 0 ? (
          <Box
            sx={{
              textAlign: "center",
              py: 4,
              color: "text.secondary",
            }}
          >
            <NoteIcon sx={{ fontSize: 48, mb: 2, opacity: 0.5 }} />
            <Typography variant="h6" gutterBottom>
              No notes yet
            </Typography>
            <Typography variant="body2">
              Select text and click the note icon to add notes
            </Typography>
          </Box>
        ) : (
          <Box>
            {notes.map((note, index) => (
              <Box key={index}>
                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", mb: 1 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{
                        color: "#9D2235",
                        fontWeight: 600,
                        fontSize: "0.875rem",
                      }}
                    >
                      Note {index + 1}
                    </Typography>
                    
                    {/* Part and Extract info */}
                    {(note.part || note.extractName) && (
                      <Typography
                        variant="caption"
                        sx={{
                          color: "#9D2235",
                          bgcolor: "rgba(157, 34, 53, 0.1)",
                          px: 1,
                          py: 0.5,
                          borderRadius: 1,
                          fontSize: "0.75rem",
                          fontWeight: 500,
                          border: "1px solid rgba(157, 34, 53, 0.2)",
                        }}
                      >
                        {note.part && `Part ${note.part}`}
                        {note.extractName && ` • ${note.extractName}`}
                      </Typography>
                    )}
                  </Box>
                  
                  {/* Selected text */}
                  <Typography
                    variant="body2"
                    sx={{
                      bgcolor: "#f5f5f5",
                      p: 1.5,
                      borderRadius: 1,
                      borderLeft: "4px solid #9D2235",
                      fontStyle: "italic",
                      mb: 1,
                      fontSize: "0.875rem",
                    }}
                  >
                    "{note.selectedText || note.text}"
                  </Typography>
                  
                  {/* User's note (if exists) */}
                  {note.userNote && (
                    <Typography
                      variant="body1"
                      sx={{
                        bgcolor: "#fff",
                        p: 1.5,
                        borderRadius: 1,
                        border: "1px solid #e0e0e0",
                        mb: 1,
                      }}
                    >
                      {note.userNote}
                    </Typography>
                  )}
                  
                  <Typography
                    variant="caption"
                    sx={{
                      color: "text.secondary",
                      mt: 1,
                      display: "block",
                    }}
                  >
                    Added at {note.timestamp}
                  </Typography>
                </Box>
                {index < notes.length - 1 && <Divider sx={{ my: 2 }} />}
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            bgcolor: "#9D2235",
            "&:hover": { bgcolor: "#7a182a" },
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotesModal;
